import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 25);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-92" data-mp="20rjvhwshf4uk">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-93" data-mp="3h6bq8gd3oo71">
        <div className="mx-auto max-w-4xl text-center" data-id="element-94" data-mp="3c8a4fnoaiarv">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-95" data-mp="3c7s003rh4q8v">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-96" data-mp="3w1t5xq09ir4j">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-97" data-mp="erv6ddx1h8ii" data-mpi={index}>
                <div data-id="element-98" data-mp="eqtig8uxcrjd">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-99" data-mp="ep8wv8ql8ixn">
                    {value}
                  </p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-100" data-mp="3i7infqeuzt6x">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-101" data-mp="3rxv8rkuhzqe4">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-102" data-mp="2zhatnyx1uf3e">
            Después sube. <b className="text-white" data-id="element-103" data-mp="2zfpziaency62">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-104" data-mp="2rftdidf81ngp">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-105" data-mp="2mh0ajexk9eus">
              <span data-id="element-106" data-mp="315mmr7rw5qhs">Cupos al precio de lanzamiento</span>
              <span data-id="element-107" data-mp="2w7l60thxu39h">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-108" data-mp="2w8wc4zyuvn3r">
              <div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-109" data-mp="28j1xqdyw1qhe" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-110" data-mp="23jpc1wjr6pge">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-111" data-mp="2idty1pjuurfv">
        <div className="mx-auto max-w-2xl" data-id="element-112" data-mp="2dg22mlk04n6x">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-113" data-mp="2djg6xzc876h0">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-114" data-mp="3ows27ltx6grk">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-115" data-mp="3rg58di1jys24">
              <div data-id="element-116" data-mp="j151qd1h8m7f">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-117" data-mp="j0lhuqs9nnqr">
                  PROTOCOLO — RESCATE SIBO™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-118" data-mp="nz6nj5qaezml">
                  5 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-119" data-mp="e9wp784uokq1">
                  Tu protocolo completo en PDF (300+ páginas) + 5 bonos
                  estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-120" data-mp="16qpkovxmrjgp">
                <p className="text-slate-500 line-through" data-id="element-121" data-mp="16sahks7f3ehq">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-122" data-mp="3f93fvznk1jmy">
                  $19.990
                </p>
                <p className="text-xs text-slate-400" data-id="element-123" data-mp="3aas59mpfr53o">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-124" data-mp="3180qbcxcpr7a">
            QUIERO MI SISTEMA AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}